<template>
  <v-container grid-list-xl fluid class="pa-0">
    <v-toolbar class="elevation-1">
      <h4>Historical List - Staff</h4>
      <v-spacer></v-spacer>
      <v-btn
        @click="filters = !filters"
        small
        color="clear"
        class="elevation-0"
      >
        Toggle Filters
      </v-btn>
    </v-toolbar>
    <v-layout column class="pl-4 pr-4 pt-3">
      <filters
        v-if="filters"
        v-model="options"
        :name="true"
        class="ml-3 mr-3 mt-2 mb-1"
      ></filters>
      <v-flex lg12>
        <v-card>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="complex.headers"
              :search="search"
              :items="complex.items"
              :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
              class="elevation-1"
              item-key="name"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.key }}</td>
                <td>{{ props.item.first_name }}</td>
                <td>{{ props.item.last_name }}</td>
                <td>
                  {{ props.item.sign_in_date || props.item.sign_out_date }}
                </td>
                <td>
                  {{ props.item.sign_in_time || props.item.sign_out_time }}
                </td>
                <td>{{ titleCase(props.item.station || "N/A") }}</td>
                <td>
                  <v-btn
                    color="info"
                    small
                    icon
                    @click="handleMoreInfo(props.item)"
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>
                  <v-btn
                    color="error"
                    small
                    icon
                    v-on:click.stop="handleDelete(props.index, props.item)"
                  >
                    <v-icon>remove</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
import HistoricalBase from "./HistoricalBase.vue";
import Helpers from "@/mixins/helpers";
export default {
  extends: HistoricalBase,
  mixins: [Helpers],
  data() {
    return {
      filters: true,
      contactType: "staff",
      editMode: "Historical Staff View",
      complex: {
        headers: [
          {
            text: "Staff ID",
            value: "key",
          },
          {
            text: "First Name",
            value: "first_name",
          },
          {
            text: "Last Name",
            value: "last_name",
          },
          {
            text: "Date",
            value: "sign_in_date" || "sign_out_date",
          },
          {
            text: "Time",
            value: "sign_in_time" || "sign_out_time",
          },
          {
            text: "Station",
            value: "station",
          },
          {
            text: "Action",
            value: "",
          },
        ],
        items: [],
      },
    };
  },
};
</script>
